import log, { initLogger } from '@vcclive/log';
import * as React from 'react';
import { render } from 'react-dom';
import './polyfills';

import App from './App';
import { mixReducers } from '../vcc-redux';
import { configureStore } from '../store';
import { clientReducer, RootState } from './client-reducer';
import { rootSaga } from './client-saga';

import './css/frame.scss';

initLogger(process.env.NODE_ENV === 'production');
const rootReducer = mixReducers<RootState>({ root: clientReducer });
const store = configureStore<RootState>(rootReducer, rootSaga);

render(
    <App store={store}/>,
    document.getElementById('root'),
);

if (process.env.NODE_ENV !== 'production') {
    FuseBox.addPlugin({
        hmrUpdate({ path, content }) {
            function endsWith(p: string, end: string) {
                return p.substr(-end.length) === end;
            }

            if (endsWith(path, '.jsx')) {
                FuseBox.flush((p: string) => endsWith(p, '.jsx'));
                FuseBox.dynamic(path, content);
                const AppWithHmr = FuseBox.import('./client/App').default;
                render(
                    <AppWithHmr store={store}/>,
                    document.getElementById('root'),
                );
                return true;
            }
            if (endsWith(path, 'client-reducer.js')) {
                FuseBox.dynamic(path, content);
                store.replaceReducer(FuseBox.import(`./${path}`).rootReducer);
                return true;
            }
            if (endsWith(path, '.scss')) {
                return false;
            }
            log.warn(`can't reload module: ${path}`);
            window.location.reload();
            return true;
        },
    });
}
